export default function HeroSection() {
  const handleScroll = (href: string) => {
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative w-full min-h-screen overflow-hidden flex flex-col">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=breathtaking%20aerial%20panoramic%20view%20of%20vast%20South%20American%20temperate%20rainforest%2C%20ancient%20dense%20canopy%20of%20native%20trees%2C%20emerald%20green%20rolling%20hills%2C%20misty%20valleys%2C%20pristine%20natural%20forest%20landscape%20at%20golden%20hour%2C%20cinematic%20wide%20angle%20photography%2C%20rich%20deep%20greens%20with%20warm%20amber%20sunlight%20filtering%20through%20leaves%2C%20sustainable%20managed%20forest%20visible%20in%20distance&width=1920&height=1080&seq=hero-forest-01&orientation=landscape"
          alt="South American Forest"
          className="w-full h-full object-cover object-top"
        />
        {/* Gradient overlays */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/20 via-transparent to-black/20"></div>
      </div>

      {/* Content — flex-1 fills the space between top and stats bar */}
      <div className="relative z-10 flex flex-col items-center justify-center flex-1 px-4 text-center w-full pt-28 pb-12">
        {/* Pill label */}
        <div className="inline-flex items-center gap-2 px-4 py-2 border border-white/40 rounded-full mb-6 bg-white/10 backdrop-blur-sm">
          <span className="w-2 h-2 rounded-full bg-[#7AA882] inline-block"></span>
          <span className="text-white/90 text-xs font-medium tracking-widest uppercase">
            Global Forest Products · Local Expertise
          </span>
        </div>

        {/* Main title */}
        <h1 className="font-playfair text-4xl md:text-6xl lg:text-7xl text-white font-semibold leading-tight max-w-5xl mb-6">
          Premium Forest Products<br />
          <em className="font-playfair italic font-normal">From South America and the World to the U.S.</em>
        </h1>

        {/* Subtitle */}
        <p className="text-white/80 text-base md:text-lg font-light max-w-2xl leading-relaxed mb-10">
          Transparent, efficient, and responsible brokerage — connecting world-class
          producers with the U.S. market.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 items-center">
          <button
            onClick={() => handleScroll('#products')}
            className="px-8 py-3.5 bg-[#2D5E3F] text-white text-sm font-medium rounded-full hover:bg-[#1C3A2C] transition-colors duration-200 cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            Explore Products
            <i className="ri-arrow-right-line"></i>
          </button>
          <button
            onClick={() => handleScroll('#contact')}
            className="px-8 py-3.5 bg-white/10 border border-white/40 text-white text-sm font-medium rounded-full hover:bg-white/20 transition-colors duration-200 cursor-pointer whitespace-nowrap backdrop-blur-sm"
          >
            Request a Quote
          </button>
        </div>

        {/* Scroll indicator — hidden on mobile to avoid crowding */}
        <div className="hidden md:flex flex-col items-center gap-2 opacity-60 mt-12">
          <span className="text-white text-xs tracking-widest uppercase">Scroll</span>
          <div className="w-px h-12 bg-white/50 animate-pulse"></div>
        </div>
      </div>

      {/* Stats bar — sits at the natural bottom of the section, never overlaps content */}
      <div className="relative z-10">
        <div className="bg-white/10 backdrop-blur-md border-t border-white/20">
          <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { value: '20+', label: 'Years of Experience' },
              { value: '10+', label: 'Product Lines' },
              { value: '100%', label: 'Sustainable Focus' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-white text-2xl font-bold font-playfair">{stat.value}</div>
                <div className="text-white/70 text-xs font-medium mt-0.5">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
